import { useState, useRef, useEffect } from "react";
import { Box, Chip } from "@mui/material";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import useResizeObserver from "use-resize-observer";

const useStyles = makeStyles<Theme>((theme: Theme) => {
    return {
        chip: {
            margin: theme.spacing(0.5),
            fontWeight: 600,
            height: 28,
            borderWidth: "1px",
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.light,
            background: theme.palette.primary.light,
            "&:hover, &:focus": {
                background: `${theme.palette.primary.light} !important`,
                boxShadow: "0 2px 7px 0 #00000026",
            },
            "& .MuiChip-label": {
                maxWidth: 160,
                textOverflow: "ellipsis",
                whiteSpace: "pre",
                overflow: "hidden",
                fontSize: 14,
                fontWeight: 400,
                height: 24,
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
                color: theme.palette.text.primary,
                letterSpacing: "0.4px",
            },
            "& .MuiChip-deleteIcon": {
                color: theme.palette.text.primary,
                width: 18,
                "&:hover": {
                    color: theme.palette.text.primary,
                },
            },
        },
    };
});

const TeamChips = ({ chips }: { chips: any[] }) => {
    const classes = useStyles();

    const [chipConfig, setChipConfig] = useState<any>(null);
    const [hiddenChipsCount, setHiddenChipsCount] = useState(0);

    const chipRefs = useRef<HTMLDivElement[]>([]);
    const chipsWrapperRef = useRef<HTMLDivElement>(null);
    const { ref: resizableWrapper, width = -1, height = -1 } = useResizeObserver<HTMLDivElement>();

    useEffect(() => {
        // Get 1st chip as reference for Y position and height.
        const config = chipRefs.current[0].getBoundingClientRect();
        setChipConfig(config);

        // Count all chips which y is higher than the reference. Those are the +nn chips
        setHiddenChipsCount(
            chipRefs.current.filter((chip) => chip.getBoundingClientRect().y > config.y + config.height).length
        );
    }, [width, height]);

    const handleChipClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.stopPropagation();
    };

    return (
        <Box
            sx={{ display: "flex", flexWrap: "nowrap", alignItems: "center", position: "relative" }}
            ref={resizableWrapper}
        >
            <Box
                sx={{
                    height: chipConfig?.height + 4,
                    overflow: "hidden",
                    // outline: "1px solid",
                }}
                ref={chipsWrapperRef}
            >
                {chips.map((chip, i) => (
                    <Chip
                        onClick={handleChipClick}
                        color="default"
                        className={classes.chip}
                        key={chip.id}
                        label={chip.name}
                        ref={(el) => {
                            chipRefs.current[i] = el as HTMLDivElement;
                        }}
                    />
                ))}
            </Box>
            {Boolean(hiddenChipsCount) && <Chip className={classes.chip} label={`+${hiddenChipsCount}`} />}
        </Box>
    );
};

export default TeamChips;
